import { AbortError } from '@app/errors/AbortError'

/** puts eventloop task to sleep */
export function sleep(ms: number = 1000, abortSignal?: AbortSignal): Promise<void> {
  return new Promise<void>((resolve, reject) => {
    if (abortSignal?.aborted) {
      reject(new AbortError('Sleep was aborted'))
      return
    }

    let timeout: ReturnType<typeof setTimeout> | null = null

    const onAbort = () => {
      if (timeout !== null) {
        clearTimeout(timeout)
        timeout = null
      }
      reject(new AbortError('Sleep was aborted'))
    }

    timeout = setTimeout(() => {
      timeout = null
      abortSignal?.removeEventListener('abort', onAbort)
      resolve()
    }, ms)

    abortSignal?.addEventListener('abort', onAbort, { once: true })
  })
}
